// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"529":"b030b5f5","653":"ef5afe01"}[chunkId] + ".chunk.js";
};